import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
const avatars = [{
  title: 'Ti senti "Gonfia" ogni mattina',
  desc: 'Anche se mangi poco, il tuo addome sembra sempre infiammato.'
}, {
  title: 'La bilancia è bloccata',
  desc: 'Hai provato ogni dieta, ma per la tua tiroide nulla sembra funzionare.'
}, {
  title: 'Capelli e pelle spenti',
  desc: 'Noti una caduta eccessiva e una pelle secca che non migliora con le creme.'
}, {
  title: 'Mani e piedi freddi',
  desc: 'Un segno classico che il tuo termostato interno (la tiroide) è spento.'
}, {
  title: 'Vuoi soluzioni pratiche',
  desc: 'Non hai ore da passare in cucina, cerchi ricette veloci per la vita frenetica di oggi.'
}];
export function AvatarSection() {
  return <section className="py-8 px-4 bg-brand-bg" data-id="element-18">
      <div className="max-w-2xl mx-auto" data-id="element-19">
        <h2 className="text-xl sm:text-2xl font-heading font-bold text-brand-primary text-center mb-6" data-id="element-20">
          Questa risorsa è per te se ti riconosci qui sotto:
        </h2>

        <div className="space-y-3" data-id="element-21">
          {avatars.map((item, i) => <div key={i} className="bg-white border border-brand-border rounded-lg p-4 flex gap-3 items-start" data-id="element-22">
              <CheckCircle2Icon className="w-5 h-5 text-brand-primary shrink-0 mt-0.5" data-id="element-23" />
              <div data-id="element-24">
                <h3 className="font-bold text-brand-primary text-sm sm:text-base mb-1" data-id="element-25">
                  {item.title}:
                </h3>
                <p className="text-sm text-brand-text" data-id="element-26">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}